import { PluginRegistrationProps } from "./register-plugins";

export class TemplateTagInfo {
  text: string = "";
  tag: string = "";
  children: TemplateTagInfo[] = []
}

export default function TemplateTagPlugin({ editor }: PluginRegistrationProps) {
  if (!editor) return;
  let buttonName = editor.getParam("variable_button_text");
  let variables = editor.getParam("variable_list");
  let buildButtonMenuForButton = (items: TemplateTagInfo[]): any[] => {
    if (items.length === 0) return [];
    return items.map((t) => {
      if (t.text == "|") {
        let newSeparator = {
             type: 'separator'
        };
        return newSeparator;
      } else{
        let newItem = {
          type: t.children.length > 0 ? 'nestedmenuitem' : 'menuitem',
          text: t.text,
          onAction: () => editor.insertContent(t.tag),
          getSubmenuItems: () => buildButtonMenuForButton(t.children)
        };
        return newItem;
      }
    });
  };

  editor.ui.registry.addMenuButton('templatetags', {
    text: buttonName || 'Template Tags',
    fetch: (callback) => {
      const items: any[] = buildButtonMenuForButton(variables)
      callback(items);
    }
  });
};
